/* ============
 * Order Type Transformer
 * ============
 *
 * The transformer for the orderType.
 */

import Transformer from './transformer';

export default class OrderTransformer extends Transformer {

  static fetch(orderType) {
    return {
      id: orderType.id,
      name: orderType.name,
    };
  }

  static send(orderType) {
    return {
      id: orderType.id,
      name: orderType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/orderType.js